import React, { useEffect, useRef } from 'react';
import Sketch from 'react-p5';

const P5ShinkaiBackground = () => {
  const particlesRef = useRef([]);
  const canvasRef = useRef(null);
  const timeRef = useRef(0);

  // 初始化粒子
  const initElements = (p5, width, height) => {
    // 更多的粒子，更好的星空效果
    particlesRef.current = Array.from({ length: 250 }, () => ({
      x: p5.random(width),
      y: p5.random(height),
      size: p5.random(1, 4),
      speed: p5.random(0.05, 0.6),
      alpha: p5.random(70, 220),
      twinkleSpeed: p5.random(0.01, 0.05),
      twinkleOffset: p5.random(0, p5.TWO_PI)
    }));
  };

  const setup = (p5, canvasParentRef) => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const canvas = p5.createCanvas(width, height).parent(canvasParentRef);
    canvasRef.current = canvas;
    p5.noStroke();
    p5.frameRate(30); // 控制帧率以优化性能
    initElements(p5, width, height);
  };

  const draw = (p5) => {
    timeRef.current += 0.01;

    // 渐变天空背景 - 更柔和的新海诚风格色彩
    const skyGradient = p5.drawingContext.createLinearGradient(0, 0, 0, p5.height);
    skyGradient.addColorStop(0, p5.color(100, 160, 240, 255)); // 顶部蓝色
    skyGradient.addColorStop(0.4, p5.color(80, 140, 230, 255)); // 上中部蓝色
    skyGradient.addColorStop(0.7, p5.color(60, 100, 200, 255)); // 下中部蓝色
    skyGradient.addColorStop(1, p5.color(30, 50, 150, 255)); // 底部深蓝色
    p5.drawingContext.fillStyle = skyGradient;
    p5.rect(0, 0, p5.width, p5.height);

    // 更新和绘制粒子 - 闪烁效果
    particlesRef.current.forEach(particle => {
      particle.y -= particle.speed;
      if (particle.y < 0) {
        particle.y = p5.height;
        particle.x = p5.random(p5.width);
      }

      // 添加闪烁效果
      const twinkle = p5.sin(timeRef.current * particle.twinkleSpeed + particle.twinkleOffset);
      const alpha = particle.alpha * (0.7 + 0.3 * twinkle);

      p5.fill(255, 255, 255, alpha);
      p5.ellipse(particle.x, particle.y, particle.size);
    });
  };

  const windowResized = (p5) => {
    p5.resizeCanvas(window.innerWidth, window.innerHeight);
    initElements(p5, window.innerWidth, window.innerHeight);
  };

  // 清理
  useEffect(() => {
    return () => {
      if (canvasRef.current) {
        canvasRef.current.remove();
      }
    };
  }, []);

  return (
    <Sketch
      setup={setup}
      draw={draw}
      windowResized={windowResized}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 0,
        width: '100%',
        height: '100%'
      }}
    />
  );
};

export default P5ShinkaiBackground;
